import { useCallback } from 'react';
import { useNavigate } from 'react-router';

import type { DialogKey } from 'components/navigation/WithDialogs';

import { useGenerateDialogPath } from './useGenerateDialogPath';

export const useOpenDialog = () => {
  const navigate = useNavigate();
  const generatedPath = useGenerateDialogPath();
  return useCallback(
    (
      dialogKey: DialogKey,
      dialogParam: string,
      opts?: {
        basePath?: string;
        replace?: boolean;
        additionalParams?: Record<string, string | string[]>;
      }
    ) => {
      const { replace, ...rest } = opts || {};
      navigate(generatedPath(dialogKey, dialogParam, rest), {
        preventScrollReset: true,
        replace,
      });
    },
    [generatedPath, navigate]
  );
};
